import React, { useState, useEffect, useRef } from 'react'
import Formsy from 'formsy-react'
import clsx from 'clsx'
import {
  Button,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import { TextInput } from 'app/components/FormsyHelperComponent'
import { MAX_GROUP_TITLE_TEXT_LENGTH } from 'commons/groupForm'
import { useFormsy } from 'commons/form'
import CancelButton from 'app/components/buttons/CancelButton'
import ResponsiveDialog from 'app/components/dialog/ResponsiveDialog'
import useMobileStyle from 'app/components/mobileModal/mobileModalStyle'

export default (props) => {
  const [isFormValid, setIsFormValid] = useState(false)
  const {
    state,
    classes,
    groupDetails,
    hendleUpdateName,
    toggleDialogs,
    RENAME_GROUP_DIALOG,
  } = props

  const mobileClasses = useMobileStyle()

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    reset()
    setIsFormValid(false)
  }, [state[RENAME_GROUP_DIALOG]])
  /* eslint-enable react-hooks/exhaustive-deps */

  const formRef = useRef(null)
  const { isPristine, onChange, reset } = useFormsy(formRef)

  function disableButton() {
    setIsFormValid(false)
  }

  function enableButton() {
    setIsFormValid(true)
  }

  return (
    <ResponsiveDialog
      fullWidth
      isFullScreen={false}
      className={clsx(
        classes.groupDialog,
        classes.groupDialogStyleOne,
        mobileClasses.lessPaddingMobile,
      )}
      open={state[RENAME_GROUP_DIALOG]}
    >
      <DialogTitle className={classes.groupDeleteTitle}>
        <FormattedMessage id="group.details.dialogs.renameTitle" />
      </DialogTitle>

      <DialogContent>
        <Formsy
          onValidSubmit={hendleUpdateName}
          onChange={onChange}
          onValid={enableButton}
          onInvalid={disableButton}
          ref={formRef}
          className="flex flex-col justify-center w-full"
          id="renameGroup"
        >
          <TextInput
            margin="dense"
            value={groupDetails.name}
            containerClassName="mt-16"
            labelId="group.details.dialogs.groupName"
            placeholderId="group.details.dialogs.groupName"
            name="name"
            variant="outlined"
            rows={5}
            autoFocus
            fullWidth
            maxLength={MAX_GROUP_TITLE_TEXT_LENGTH}
            required
          />
        </Formsy>
      </DialogContent>
      <DialogActions className={classes.renameActionBtns}>
        <CancelButton
          onClick={() => {
            toggleDialogs(RENAME_GROUP_DIALOG, false)
          }}
          className={mobileClasses.modalBtn}
        />
        <Button
          disabled={!isFormValid || isPristine}
          type="submit"
          color="primary"
          className={clsx(
            classes.actionBtn,
            classes.groupActionBtns,
            mobileClasses.modalBtn,
          )}
          variant="contained"
          form="renameGroup"
        >
          <FormattedMessage id="action.save" />
        </Button>
      </DialogActions>
    </ResponsiveDialog>
  )
}
